module.exports = __webpack_public_path__ + "img/pimec.327a33cd.png";